import { Deserializable } from './deserializable';
import { ExerciseModel } from './exercise.model';
import { ExercisepartModel } from './exercisepart.model';

export class ExerciseversionModel implements Deserializable {

  // columns
  id: number;
  hashed_id: string; // tslint:disable-line: variable-name
  version: string;
  published_at: any; // tslint:disable-line: variable-name

  // exercise
  exercise: ExerciseModel;
  exerciseparts: Array<ExercisepartModel>;

  deserialize(input: any): this {
    Object.assign(this, input);
    // exercise
    if (this.exercise !== null && this.exercise !== undefined) {
      this.exercise = new ExerciseModel().deserialize(this.exercise);
    }
    // exerciseparts
    let exerciseparts = null;
    if (this.exerciseparts !== null && this.exerciseparts !== undefined) {
      exerciseparts = [];
      this.exerciseparts.forEach((exercisepart: ExercisepartModel) => {
        exerciseparts.push(new ExercisepartModel().deserialize(exercisepart));
      });
    }
    this.exerciseparts = exerciseparts;
    return this;
  }

}
